import React, { useEffect, useState } from "react";
import { editProduct, getCategories, getProduct } from "../../configs/productsConfig";
import { useNavigate, useParams } from 'react-router-dom';
import { domain } from "../../configs/auth";
import toast from "react-hot-toast";


function AdminEditProduct() {

    const { tableName, productId } = useParams();
    const [isSaving, setIsSaving] = useState(false);
    const navigate = useNavigate();
    const [option, setOption] = useState({
        id: null,
        option: '1',
        price: '',
        stock: '',
        discountPrice: '',
        weight: '',
        unitType: ''
    });
    const [categories, setCategories] = useState([]);
    const [productData, setProductData] = useState({name: '', category_id: '', description: '', images:[], uploadedImages: [], guide: ''});
    const [productDetails, setProductDetails] = useState([{id: "", option: "", stock: "", price: "", discountPrice: "", weight : "", unitType: ""}]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (tableName && productId) {
                    const data = await getProduct(tableName, productId);
    
                    const imagesArray = Array.isArray(data.images)
                        ? data.images
                        : data.images ? data.images.split(',').map(image => image.trim()) : [];
    
                    const details = parseProductDetails(data.product_details);
    
                    setProductData((prevData) => ({
                        ...prevData,
                        ...data,
                        images: imagesArray,
                    }));
    
                    setProductDetails(details);
    
                    const categories = await getCategories(tableName);
                    setCategories(categories);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
    
        const parseProductDetails = (productDetails) => {
            let details;
            if (productDetails.includes(",")) {
                details = productDetails.split(",").map((optionStr) => {
                    const [id, option, stock, price, discountPrice, weight, unitType] = optionStr.split(":");
                    return { id, option, stock, price, discountPrice, weight, unitType };
                });
            } else {
                const [id, option, stock, price, discountPrice, weight, unitType] = productDetails.split(":");
                details = [{ id, option, stock, price, discountPrice, weight, unitType }];
            }
            return details;
        };
    
        fetchData();
    }, [tableName, productId]);
    

    const deleteProductOption = (indexToDelete) => {
        const updatedOptions = productDetails.filter((_, index) => index !== indexToDelete);
        setProductDetails(updatedOptions);
    };

    const handleAddOption = (option) => {
        setProductDetails((prevData) => [
            ...prevData,
            {
                id: option.id || null, 
                option: option.option,
                stock: option.stock,
                price: option.price,
                discountPrice: option.discountPrice,
                weight: option.weight,
                unitType: option.unitType
            }
        ]);
        setOption({id: null, option: '1', price: '', discountPrice: '', stock: '', weight: '', unitType: ''});
    };

    const handleImageChange = (e) => {
        const selectedFiles = Array.from(e.target.files);

        if (selectedFiles.length + productData.uploadedImages.length > 4) {
            toast.error("Maximum 4 képet tudsz feltölteni.");
            return;
        }

        const images = selectedFiles.map((file) => ({
            file, // Tárold a fájl objektumot
            url: URL.createObjectURL(file), // Generálj blob URL-t
            name: file.name,
            type: file.type,
        }));

        setProductData((prevData) => ({
            ...prevData,
            uploadedImages: [...prevData.uploadedImages, ...images]
        }));

        e.target.value = '';
    };

    const handleNewImageDelete = (indexToDelete) => {
        const updatedImages = productData.uploadedImages.filter((_, index) => index !== indexToDelete);
        setProductData((prevData) => ({
            ...prevData,
            uploadedImages: [...updatedImages]
        })); 
    };

    const handleGuideDelete = () => {
        setProductData((prevData) => ({
            ...prevData,
            guide: ''
        }));
    };

    const handleDelete = (indexToDelete) => {
        const newImages = productData.images.filter((_, index) => index !== indexToDelete);
        setProductData((prevData) => ({ ...prevData, images: [...newImages] }));
    };

    const saveEditedProduct = async () => {
        setIsSaving(true);

        try {
            const res = await editProduct(productData, productDetails, tableName);
            if (res.success) {
                navigate(`/products/${tableName}`);
            };
        } catch (err) {
            console.error(err);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="container-fluid p-0">

            <div className="container-lg mt-4">

                <div className="d-flex flex-column justify-content-center align-items-center">

                    <div className="form-floating mb-3 col-lg-6 col-10">
                        <input type="text" className="form-control" id="productName" placeholder="" value={productData.name}
                            onChange={(e) =>
                                setProductData((prevData) => ({
                                    ...prevData,
                                    name: e.target.value,
                                }))
                            } required />
                        <label htmlFor="productName">Termék neve</label>
                    </div>

                    <div className="form-floating mb-3 col-lg-6 col-10">
                        <select className="form-select" id="category" aria-label="Kategória" value={productData.category_id}
                            onChange={(e) =>
                                setProductData((prevData) => ({
                                    ...prevData,
                                    category_id: e.target.value,
                                }))}>
                           
                           <option value={productData.category_id}>
                            {
                                categories.find(category => category.id == productData.category_id)?.category_name
                            }
                            </option>


                            {
                                categories.map(category => (
                                    <option value={category.id} key={category.id}>{category.category_name}</option>
                                ))
                            }

                        </select>
                        <label htmlFor="category">Kategória</label>
                    </div>

                    <div className="form-floating pb-3 mb-2 col-lg-6 col-10 border-bottom">
                        <textarea className="form-control h-100" placeholder="Termék leírása" id="productDescription" maxLength={1000} rows={15} value={productData.description}
                            onChange={(e) =>
                                setProductData((prevData) => ({
                                    ...prevData,
                                    description: e.target.value,
                                }))} required></textarea>
                        <label htmlFor="productDescription">Termék leírása</label>
                    </div>

                    <div className="col-lg-6 col-10 border-bottom mb-2">
                        <p className="m-0">Ha nincsenek termék opciók, 1-et kell írni az opció helyére.</p>
                        <div className="form-floating mb-3">
                            <input type="text" className="form-control" id="productOption" placeholder="" required value={option.option} onChange={(e)=>setOption((prevData)=>({
                                ...prevData,
                                option: e.target.value
                            }))}/>
                            <label htmlFor="productOption">Termék opció</label>
                        </div>

                        <div className="form-floating mb-3">
                            <input type="number" className="form-control" id="productPrice" placeholder="" required value={option.price} onChange={(e)=>setOption((prevData)=>({
                                ...prevData,
                                price: e.target.value
                            }))}/>
                            <label htmlFor="productPrice">Termék ára</label>
                        </div>

                        <div className="form-floating mb-3">
                            <input type="number" className="form-control" id="productDiscountPrice" placeholder="" required value={option.discountPrice} onChange={(e)=>setOption((prevData)=>({
                                ...prevData,
                                discountPrice: e.target.value
                            }))}/>
                            <label htmlFor="productDiscountPrice">Kedvezményes ár</label>
                        </div>

                        <div className="form-floating mb-3">
                            <input type="number" className="form-control" id="productWeight" placeholder="" required value={option.weight} onChange={(e)=>setOption((prevData)=>({
                                ...prevData,
                                weight: e.target.value
                            }))}/>
                            <label htmlFor="productWeight">Termék súlya</label>
                        </div>

                        <div className="d-flex flex-sm-row flex-column align-items-center justify-content-center col-12 mb-3">

                            <div className="form-floating col-sm-4 me-2">
                                <input type="number" className="form-control" id="productStock" placeholder=""  required value={option.stock} onChange={(e)=>setOption((prevData)=>({
                                ...prevData,
                                stock: e.target.value
                            }))}/>
                                <label htmlFor="productStock">Elérhető készlet</label>
                            </div>

                            <div>
                                <input className="form-check-input" type="checkbox" value="piece" onChange={(e) => setOption((prevData) => ({
                                    ...prevData,
                                    unitType: e.target.value,
                                }))} checked={option.unitType === "piece"} id="unitPiece"></input>
                                <label className="form-check-label me-5 ms-2" htmlFor="unitPiece">
                                    Darab
                                </label>
                            </div>
                            <div>
                                <input className="form-check-input" type="checkbox" value="package" onChange={(e) => setOption((prevData) => ({
                                    ...prevData,
                                    unitType: e.target.value,
                                }))} checked={option.unitType === "package"} id="unitPackage"></input>
                                <label className="form-check-label me-5 ms-2" htmlFor="unitPackage">
                                    Csomag
                                </label>
                            </div>

                        </div>
                    </div>
                        <button className="btn btn-home-primary col-sm-5 col-12  my-3" onClick={()=>handleAddOption(option)}>Termék variáció létrehozása</button>

                </div>

            </div>

            <div className="container-lg col-md-8 table-responsive">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th>Opció</th>
                            <th>Ár</th>
                            <th>Kedvezményes ár</th>
                            <th>Készlet</th>
                            <th>Súly</th>
                            <th>Mennyiség típus</th>
                        </tr>
                    </thead>
                    <tbody>
                        {productDetails.map((optionDetail, index) => (
                            <tr key={index}>
                                <td scope="row">
                                    <button className="btn" onClick={() => deleteProductOption(index)}>X</button>
                                </td>
                                <td scope="row">
                                    <button className="btn" onClick={() => {
                                        setOption({
                                            id: optionDetail.id,
                                            option: optionDetail.option,
                                            price: optionDetail.price,
                                            discountPrice: optionDetail.discountPrice,
                                            stock: optionDetail.stock,
                                            weight: optionDetail.weight,
                                            unitType: optionDetail.unitType
                                        });
                                        deleteProductOption(index);
                                    }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil" viewBox="0 0 16 16">
                                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                                        </svg>
                                    </button>
                                </td>
                                <td>{optionDetail.option}</td>
                                <td>{optionDetail.price} Ft</td>
                                {
                                    optionDetail.discountPrice == 'NULL' || '' ? <td>-</td> : <td>{optionDetail.discountPrice} Ft</td>
                                }
                                <td>{optionDetail.stock} db</td>
                                <td>{optionDetail.weight} kg</td>
                                <td>{optionDetail.unitType === 'piece' ? 'Darab' : 'Csomag'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            
            <div className={`container-lg mb-3 ${tableName === 'prepared_materials' ? '' : 'd-none'} d-flex flex-column align-items-center`}>
                <div className="col-lg-6">
                    <div className={`${productData.guide === '' || productData.guide === '/undefined' ? 'd-none' : ''} mb-2 d-flex flex-row`}>
                       <a href={domain + productData.guide} 
                    className='me-2'
                    >Útmutató a termék elkészítéséhez</a>
                    <button className="btn p-0 px-1 border" onClick={handleGuideDelete}>Törlés</button>
                    </div>
                    

                    <h5>Útmutató feltöltés:</h5>
                    <input type="file" name="guide"
                        accept="application/pdf"
                        onChange={(e) => {
                            const pdfFile = e.target.files[0];
                            setProductData((prevData) => ({
                                ...prevData,
                                guide: pdfFile
                            }));
                        }} />
                </div>
            </div>


            <div className="container-lg d-flex flex-column align-items-center mb-3">
                <div className="col-lg-6">

                    <div>
                        {
                            productData.images.map((image, index)=>(
                              <div key={index} className="d-inline-block position-relative m-1">
                                <img src={`${image}`} alt={`Product image ${index + 1}`} style={{ width: "150px" }} />
                                <button
                                    onClick={() => handleDelete(index)}
                                    className="btn p-1 rounded-0 position-absolute top-0 end-0 text-white bg-primary"
                                >
                                    X
                                </button>
                            </div>  
                            ))
                            
                        }
                    </div>

                    <div className="d-flex flex-row">
                        <h5 className="me-2">Képfeltöltés:</h5>
                        <input type="file" className="uploadImageInput" multiple onChange={handleImageChange} />
                    </div>
                    

                    <div>
                        {productData.uploadedImages.map((image, index) => (
                            <div key={index} className="d-inline-block position-relative m-2">
                                <img src={image.url} alt={`Uploaded image ${index + 1}`} style={{ width: "150px" }} />
                                <button
                                    onClick={() => handleNewImageDelete(index)}
                                    className="btn p-1 rounded-0 position-absolute top-0 end-0 text-white bg-primary"
                                >
                                    X
                                </button>
                            </div>
                        ))}
                    </div> 
                </div>
            </div>

            <div className="d-flex w-100 justify-content-center align-items-center">
                <button className="btn btn-primary col-md-2 col-6 mb-4" onClick={saveEditedProduct} disabled={isSaving}>
                    {isSaving ? (
                        <>
                            Mentés...
                            <span className="spinner-border spinner-border-sm ms-2" role="status" />
                        </>
                    ) : (
                        'Mentés'
                    )}
                </button>
            </div>


        </div>
    );
}

export default AdminEditProduct;